import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = ["for", "textContent"]
const _hoisted_3 = ["id"]
const _hoisted_4 = ["id"]
const _hoisted_5 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      for: _ctx.id,
      textContent: _toDisplayString(_ctx.label)
    }, null, 8, _hoisted_2),
    (!_ctx.inFocus)
      ? _withDirectives((_openBlock(), _createElementBlock("input", {
          key: 0,
          type: "text",
          id: _ctx.id,
          class: _normalizeClass(["form-control", { 'is-invalid': _ctx.error }]),
          onFocusin: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onFocusIn && _ctx.onFocusIn(...args))),
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.numberWithComma) = $event))
        }, null, 42, _hoisted_3)), [
          [_vModelText, _ctx.numberWithComma]
        ])
      : _withDirectives((_openBlock(), _createElementBlock("input", {
          key: 1,
          type: "number",
          id: _ctx.id,
          class: _normalizeClass(["form-control", { 'is-invalid': _ctx.error }]),
          onFocusout: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onFocusOut && _ctx.onFocusOut(...args))),
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.inputNumber) = $event)),
          onKeyup: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args))),
          onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args))),
          ref: "inputElement"
        }, null, 42, _hoisted_4)), [
          [_vModelText, _ctx.inputNumber]
        ]),
    _createElementVNode("div", {
      class: "invalid-feedback",
      textContent: _toDisplayString(_ctx.error)
    }, null, 8, _hoisted_5)
  ]))
}